/**
 * Application root: one-time wiring, then the shell.
 *
 * The job event subscriptions and the preferences load happen here so that
 * exactly one place in the app talks to `@/ipc/api` for global state; feature
 * workstreams read the results through the store's selector hooks.
 */

import { useEffect } from "react";

// Side-effect import: registers every tab module under src/tabs/**.
import "@/shell/bootstrap";
import { AppShell } from "@/shell/AppShell";
import { initJobSubscriptions, useAppStore } from "@/store/appStore";
import { useLayout } from "@/simple/layout";
import { SimpleApp } from "@/simple/SimpleApp";

export default function App() {
  const layout = useLayout((s) => s.mode);

  useEffect(() => {
    const dispose = initJobSubscriptions();
    void useAppStore.getState().loadPreferences();
    return dispose;
  }, []);

  return layout === "simple" ? <SimpleApp /> : <AppShell />;
}
